var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#004884",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#F0F8FF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004884",
    fillRule: "nonzero",
    strokeWidth: 0.4,
    d: "M24.306 9H9.71c-.258 0-.494.143-.612.372-.119.233-.098.512.054.724L14.5 17.63l.005.008c.194.262.3.58.3.906v6.142c-.001.182.07.357.199.486.128.13.302.202.484.202.093 0 .184-.019.27-.054l3.004-1.146c.27-.082.449-.337.449-.643v-4.987c0-.326.105-.644.3-.906l.005-.008 5.348-7.534c.152-.212.173-.491.054-.724C24.8 9.143 24.564 9 24.306 9zm-5.466 8.145c-.298.405-.46.896-.46 1.4v4.886l-2.744 1.045v-5.932c0-.503-.162-.994-.461-1.399L9.983 9.831h14.05l-5.193 7.314z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFilter);
export default __webpack_public_path__ + "static/media/activeFilter.d2556ac15cdff950bc6483182ae35eea.svg";
export { ForwardRef as ReactComponent };